import { ApiPlugin } from '@/plugins';

export default class thematicCardService {
  static async fetchThematicCards({
    index = 'thematic_card',
    what = window?.drupalSettings?.sante_resultats_edito?.what,
    randomId = window?.drupalSettings?.sante_resultats_edito?.randomId,
    etb = 'treat',
    where = window?.drupalSettings?.sante_resultats_edito?.where,
  }) {
    const params = {
      index,
      what,
      where,
      randomId,
      etb,
    };
    const response = await ApiPlugin.get('/solr/request/ajax/', { params });
    return response.data;
  }

  static getThematicCardDrupalSettings() {
    const data = {
      text_standard: window?.drupalSettings?.sante_thematic_card?.directory?.standard_text,
      text_related: window?.drupalSettings?.sante_thematic_card?.directory?.related_text,
      links: window?.drupalSettings?.sante_thematic_card?.links,
      content_type: window?.drupalSettings?.sante_thematic_card?.content_type,
    };
    if (!data) {
      console.error('No data from DrupalSeetings.sante_thematic_card.');
      return {};
    }
    return data;
  }

  static async getCardByNid({
    cardNid,
    etbId = null,
    osIds = null,
    tcNid = window.drupalSettings.sante_thematic_card?.content?.nid,
    index = 'health_offer',
  }) {
    const payload = {
      index,
      etb: 'treat',
      thematic_card: 1,
      tc_nid: tcNid,
    };

    if (etbId && osIds) {
      payload.nids = JSON.stringify({
        etb: etbId,
        os: osIds,
      });
    } else {
      payload.nid = cardNid;
    }

    const queryString = new URLSearchParams(payload).toString();
    const getParams = `?${queryString}`;

    const data = await ApiPlugin.get(`/solr/request/ajax${getParams}`);

    const cards = data?.data?.datas?.response?.docs?.map((val) => ({
      ...val,
      item_id: val.its_nid,
      is_convention_type_number: val.itm_convention_type_number,
      is_field_profession: val.its_field_profession,
      uuid: val.ss_uuid,
      tus_field_adresse1: val.ss_field_address,
      tus_field_nom: val.tm_X3b_und_field_nom?.[0],
      tus_field_prenom: val.tm_X3b_und_field_prenom?.[0],
      tm_X3b_und_field_ville: val.tm_X3b_und_field_ville,
      tm_field_horaires: val.sm_field_horaires,
      tm_field_profession$name: val.tm_X3b_und_field_profession_name,
      tus_title: val.tm_X3b_und_title?.[0],
      locs_field_geolocalisation$latlon:
            val.locs_field_geolocalisation_latlon.split(',').reverse().join(','),
      tm_prof_specialities$name: val.tm_X3b_und_field_specialite_name,
      tm_field_telephone_fixe: val.tm_X3b_und_telephones || val.tm_X3b_und_etb_telephones || null,
      tm_X3b_und_convention_type: val.tm_X3b_und_convention_type,
      tm_field_add_offre_labels$name: val.tm_X3b_und_field_custom_label_permanent,
      sm_field_custom_label_permanent_label: val.sm_field_custom_label_permanent_label,
      tm_establishment_type_names: val.tm_X3b_und_establishment_type_names || val.tm_establishment_type_names,
      tm_field_site_internet$title: val.ss_field_site_internet_title && val.ss_field_site_internet ? [val.ss_field_site_internet_title] : null,
      tm_field_site_internet$url: val.ss_field_site_internet && val.ss_field_site_internet_title ? [val.ss_field_site_internet] : null,
    }));

    return cards;
  }

  static async getThematicCardsList({
    randomId,
    filtres,
    boundingBox,
    nid = window.drupalSettings.sante_thematic_card?.content?.nid,
    currentPage = 1,
    index = 'health_offer',
    where,
  }) {
    const payload = {
      index,
      etb: 'treat',
      rand_id: randomId,
      thematic_card: 1,
      tc_nid: nid,
      page: currentPage,
      where,
    };

    // Geographic zone search
    if (boundingBox) {
      payload.where = '';
      const so = boundingBox.getSouthWest();
      const ne = boundingBox.getNorthEast();
      payload.so_lon = so.lng;
      payload.so_lat = so.lat;
      payload.ne_lon = ne.lng;
      payload.ne_lat = ne.lat;
    } else if (where) {
      payload.where = where;
    }

    // apply filters
    if (filtres) {
      payload.filtres = JSON.stringify(filtres);
    }

    const queryString = new URLSearchParams(payload).toString();
    const getParams = `?${queryString}`;

    const response = await ApiPlugin.get(`/solr/request/ajax${getParams}`);
    const listTree = response.data.datas.grouped.ss_field_custom_group.groups;
    const apiDataFilter = response.data.datas.facet_formatted;
    const apiDataResult = response.data.datas.grouped.ss_field_custom_group.ngroups;
    const isLastPage = !response.data?.datas?.grouped.ss_field_custom_group?.ngroups || response.data.datas.grouped.ss_field_custom_group.ngroups <= (25 * currentPage);
    const resultCards = (listTree || []).map((listTreeElement) => ({ ...(listTreeElement.doclist.docs[0] || {}), timezone: 'Europe/Paris' }));
    const cards = resultCards.map((val) => ({
      ...val,
      item_id: val.its_nid,
      is_convention_type_number: val.itm_convention_type_number,
      is_field_profession: val.its_field_profession,
      uuid: val.ss_uuid,
      tus_field_adresse1: val.ss_field_address,
      tus_field_nom: val.tm_X3b_und_field_nom?.[0],
      tus_field_prenom: val.tm_X3b_und_field_prenom?.[0],
      tm_X3b_und_field_ville: val.tm_X3b_und_field_ville,
      tm_field_horaires: val.sm_field_horaires,
      tm_field_profession$name: val.tm_X3b_und_field_profession_name,
      tus_title: val.tm_X3b_und_title?.[0],
      locs_field_geolocalisation$latlon:
            val.locs_field_geolocalisation_latlon.split(',').reverse().join(','),
      tm_prof_specialities$name: val.tm_X3b_und_field_specialite_name,
      tm_field_telephone_fixe: val.tm_X3b_und_telephones || val.tm_X3b_und_etb_telephones || null,
      tm_X3b_und_convention_type: val.tm_X3b_und_convention_type,
      tm_field_add_offre_labels$name: val.tm_X3b_und_field_custom_label_permanent,
      sm_field_custom_label_permanent_label: val.sm_field_custom_label_permanent_label,
      tm_establishment_type_names: val.tm_X3b_und_establishment_type_names || val.tm_establishment_type_names,
      tm_field_site_internet$title: val.ss_field_site_internet_title && val.ss_field_site_internet ? [val.ss_field_site_internet_title] : null,
      tm_field_site_internet$url: val.ss_field_site_internet && val.ss_field_site_internet_title ? [val.ss_field_site_internet] : null,
    }));

    const tcBbox = where && where !== '' ? response.data.infos.tc_bbox : null;
    const inArea = response.data.infos?.inarea;

    return {
      cards, isLastPage, apiDataFilter, apiDataResult, tcBbox, inArea,
    };
  }

  static async getThematicAllCardsList({ // get cards
    filtres,
    nid = window.drupalSettings.sante_thematic_card?.content?.nid,
    index = 'health_offer',
  }) {
    const payload = {
      index,
      etb: '',
      rand_id: 0,
      thematic_card: 1,
      tc_nid: nid,
      page: 1,
      qty: 1000000,
      iframe: 1,
    };

    // apply filters
    if (filtres) {
      payload.filtres = JSON.stringify(filtres);
    }

    const queryString = new URLSearchParams(payload).toString();
    const getParams = `?${queryString}`;

    const response = await ApiPlugin.get(`/solr/request/ajax${getParams}`);
    return response.data.datas.grouped.ss_field_custom_group.groups;
  }

  static getThematicCardsInfos() {
    return window.drupalSettings?.sante_thematic_card?.content;
  }

  static getFilterDrupalSettings() {
    const data = window?.drupalSettings?.sante_thematic_card?.content;
    if (!data) {
      console.error('No data from DrupalSeetings.sante_thematic_card.');
      return {};
    }
    return data;
  }

  static async getFilterData() {
    const dataApi = await this.getThematicCardsList({});
    const dataSetting = this.getFilterDrupalSettings();
    return {
      dataApiInfo: dataApi?.datas?.facet_formatted,
      dataSettingInfo: dataSetting,
    };
  }
}
